import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-pause-circle",
  "use": "icon-s-pause-circle-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-pause-circle\"><path d=\"M11 22C4.925 22 0 17.075 0 11S4.925 0 11 0s11 4.925 11 11-4.925 11-11 11m0-2a9 9 0 1 0 0-18 9 9 0 0 0 0 18M8 6h2v10H8zm4 0h2v10h-2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol